import { Query } from '../Model/Query';
import { v4 as v4uuid } from "uuid";
import { getCurrentUser } from "./session";
import { LegalGuardian } from '../Model/LegalGuardian';
import { Third } from '../Model/Third';
export class LegalGuardianService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(third_id, diligence_id) {
        if (diligence_id) {
            const response = await this.apiService.get('legalguardian/' + diligence_id + '/third_id/' + third_id);
            if (!response.ok) {
                throw new Error(`Error al obtener el representante.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener representante.`);
        }
    }
    async findByDiligenceNumber(id) {
        if (id) {
            const response = await this.apiService.get('legalguardian/' + id);
            if (!response.ok) {
                throw new Error(`Error al obtener el representante.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener representante.`);
        }
    }
    async findThirds(opts) {
        var _a, _b;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.diligenceId) {
                query.addFilter('diligence_id', [opts.filters.diligenceId]);
            }
            if ((_b = opts.filters) === null || _b === void 0 ? void 0 : _b.thirdId) {
                query.addFilter('third_id', [opts.filters.thirdId]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`legalguardian/thirds?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(third => new Third(third).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async saveLegalGuardian(legalGuardian) {
        if (legalGuardian) {
            const response = await this.apiService.post('legalGuardian', legalGuardian);
            if (!response.ok) {
                throw new Error(`Error al guardar el representante.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener representante.`);
        }
    }
    async createLegalGuardian(thirdId, diligenceId) {
        if (thirdId && diligenceId) {
            const dateNow = new Date();
            const legalGuardian = new LegalGuardian({
                id: v4uuid(),
                ndiligencia: diligenceId,
                representante: thirdId,
                date_time: dateNow,
                colegiado: null,
                usuario: getCurrentUser().id
            });
            const response = await this.apiService.post('legalGuardian', legalGuardian.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el repesentante`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el representante`);
        }
    }
    async deleteLegalGuardian(thirdId) {
        if (thirdId) {
            const response = await this.apiService.post('legalguardian/delete', { id: thirdId });
            if (!response.ok) {
                throw new Error(`Error al eliminar el representante.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el representante.`);
        }
    }
}
